<div class="flex flex-row">
  <div class="et-paper-progress-menu">
    <sc-progress-menu [items]="data.items$ | async"></sc-progress-menu>
  </div>
  <div class="flex-1 min-w-0">
    <router-outlet></router-outlet>
  </div>
</div>